(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dicmimni"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('m5-keyboard-tabs')) {
  customElements.define('m5-keyboard-tabs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const nav = this.querySelector('.mk-nav');
      const tabs = Array.from(this.querySelectorAll('[data-tab]'));
      const panels = Array.from(this.querySelectorAll('[data-pane]'));
      if (!nav || !tabs.length) return;
      const mobile = matchMedia('(max-width: 860px)');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const orientation = () => nav.setAttribute('aria-orientation', mobile.matches ? 'horizontal' : 'vertical');
      nav.setAttribute('role', 'tablist');
      const syncNavFade = () => nav.classList.toggle('at-end', nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 4);
      nav.addEventListener('scroll', syncNavFade, { signal, passive: true });
      window.addEventListener('resize', syncNavFade, { signal });
      syncNavFade();
      orientation();
      mobile.addEventListener('change', orientation, { signal });
      this.setAttribute('data-enhanced', '');
      tabs.forEach(tab => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.getAttribute('href').slice(1));
      });
      panels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabs.find(tab => tab.dataset.tab === panel.dataset.pane).id);
        panel.tabIndex = 0;
      });
      const activate = (tab, options = {}) => {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(panel => {
          const selected = panel.dataset.pane === tab.dataset.tab;
          panel.hidden = !selected;
          panel.classList.toggle('active', selected);
        });
        if (options.focusTab) tab.focus({ preventScroll: true });
        if (mobile.matches && options.revealTab) {
          nav.scrollTo({ left: tab.offsetLeft - (nav.clientWidth - tab.offsetWidth) / 2, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        }
        if (options.focusPanel) {
          const panel = panels.find(item => item.dataset.pane === tab.dataset.tab);
          panel.focus({ preventScroll: true });
          panel.scrollIntoView({ block: 'start', behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        }
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          activate(tab, { revealTab: true });
        }, { signal });
        tab.addEventListener('keydown', event => {
          const previous = mobile.matches ? 'ArrowLeft' : 'ArrowUp';
          const next = mobile.matches ? 'ArrowRight' : 'ArrowDown';
          let target;
          if (event.key === previous) target = (index - 1 + tabs.length) % tabs.length;
          if (event.key === next) target = (index + 1) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          if (event.key === ' ') target = index;
          if (target === undefined) return;
          event.preventDefault();
          activate(tabs[target], { focusTab: true, revealTab: true });
        }, { signal });
      });
      this.querySelectorAll('[data-goto]').forEach(button => {
        button.addEventListener('click', () => {
          const tab = tabs.find(item => item.dataset.tab === button.dataset.goto);
          if (tab) activate(tab, { focusPanel: true, revealTab: true });
        }, { signal });
      });
      const activateHash = () => {
        const tab = tabs.find(item => item.getAttribute('href') === location.hash);
        if (tab) activate(tab);
      };
      activate(tabs[0]);
      activateHash();
      window.addEventListener('hashchange', activateHash, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sharkz-phone-tabs"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sharkz-phone-tabs')) {
  customElements.define('sharkz-phone-tabs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const nav = this.querySelector('.sp-nav');
      const tabs = Array.from(this.querySelectorAll('[data-tab]'));
      const panels = Array.from(this.querySelectorAll('[data-pane]'));
      if (!nav || !tabs.length) return;
      const mobile = matchMedia('(max-width: 860px)');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const orientation = () => nav.setAttribute('aria-orientation', mobile.matches ? 'horizontal' : 'vertical');
      nav.setAttribute('role', 'tablist');
      const syncNavFade = () => nav.classList.toggle('at-end', nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 4);
      nav.addEventListener('scroll', syncNavFade, { signal, passive: true });
      window.addEventListener('resize', syncNavFade, { signal });
      syncNavFade();
      orientation();
      mobile.addEventListener('change', orientation, { signal });
      this.setAttribute('data-enhanced', '');
      tabs.forEach(tab => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.getAttribute('href').slice(1));
      });
      panels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabs.find(tab => tab.dataset.tab === panel.dataset.pane).id);
        panel.tabIndex = 0;
      });
      const activate = (tab, options = {}) => {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(panel => {
          const selected = panel.dataset.pane === tab.dataset.tab;
          panel.hidden = !selected;
          panel.classList.toggle('active', selected);
        });
        if (options.focusTab) tab.focus({ preventScroll: true });
        if (mobile.matches && options.revealTab) {
          nav.scrollTo({ left: tab.offsetLeft - (nav.clientWidth - tab.offsetWidth) / 2, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        }
        if (options.focusPanel) {
          const panel = panels.find(item => item.dataset.pane === tab.dataset.tab);
          panel.focus({ preventScroll: true });
          panel.scrollIntoView({ block: 'start', behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        }
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          activate(tab, { revealTab: true });
        }, { signal });
        tab.addEventListener('keydown', event => {
          const previous = mobile.matches ? 'ArrowLeft' : 'ArrowUp';
          const next = mobile.matches ? 'ArrowRight' : 'ArrowDown';
          let target;
          if (event.key === previous) target = (index - 1 + tabs.length) % tabs.length;
          if (event.key === next) target = (index + 1) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          if (event.key === ' ') target = index;
          if (target === undefined) return;
          event.preventDefault();
          activate(tabs[target], { focusTab: true, revealTab: true });
        }, { signal });
      });
      this.querySelectorAll('[data-goto]').forEach(button => {
        button.addEventListener('click', () => {
          const tab = tabs.find(item => item.dataset.tab === button.dataset.goto);
          if (tab) activate(tab, { focusPanel: true, revealTab: true });
        }, { signal });
      });
      const activateHash = () => {
        const tab = tabs.find(item => item.getAttribute('href') === location.hash);
        if (tab) activate(tab);
      };
      activate(tabs[0]);
      activateHash();
      window.addEventListener('hashchange', activateHash, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}



  } catch(e) { console.error(e); }
})();
})();
